import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

const StyledTableHeaderCellWithSubtitle = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    '& .caption': {
        whiteSpace: 'nowrap',
        fontSize: '11px !important',
        lineHeight: '16px !important',
        fontWeight: 400,
    },
    '& .main-title': {
        whiteSpace: 'nowrap',
        fontWeight: 600,
        lineHeight: '16px !important',
    },
}));

const TableHeaderCellWithSubtitle = ({ title, subTitle }) => {
    return (
        <StyledTableHeaderCellWithSubtitle>
            <Typography variant='body2' className='main-title'>
                {title}
            </Typography>
            {subTitle && (
                <Typography variant='caption' className='caption'>
                    {subTitle}
                </Typography>
            )}
        </StyledTableHeaderCellWithSubtitle>
    );
};

export default TableHeaderCellWithSubtitle;
